import * as React from "react"
import { AfterPage } from "types/afterjs"
import { Seo, Card, Typography, Divider } from "components"
import { Row, Col } from "reactstrap"

interface HelpPage {
	//
}

const HelpPage: AfterPage<HelpPage> = () => {
	return (
		<>
			<Seo
				title="راهنمای خرید"
				description="راهنمای استفاده از خدمات وب‌سایت آنتی ویروس."
				path="/help"
			/>
			<Row>
				<Col lg={12}>
					<Card title="راهنمای استفاده از خدمات وب‌سایت آنتی ویروس">
						<Typography gutterBottom variant="h6" component="h3">
							جستجو و انتخاب کالا
						</Typography>
						<Typography
							gutterBottom
							paragraph
							component="p"
							variant="body2"
						>
							برای جستجوی کالای مورد نظر خود در سایت آنتی‌ویروس از
							دو روش می‏‌توانید استفاده کنید:
						</Typography>
						<Typography
							gutterBottom
							paragraph
							component="p"
							variant="body2"
						>
							- استفاده از ابزار نوار جستجو (در صورتی که مدل یا
							برند مورد نظر خود را از قبل انتخاب کرده باشید)
						</Typography>
						<Typography
							gutterBottom
							paragraph
							component="p"
							variant="body2"
						>
							در قسمت بالای صفحه‌های سایت یک ابزار جستجو وجود دارد
							و شما می‌‏توانید با تایپ نام یا بخشی از نام آن کالا
							در نوار جستجو، به صورت مستقیم به سراغ محصول مورد نظر
							خود بروید.
						</Typography>
						<Typography
							gutterBottom
							paragraph
							component="p"
							variant="body2"
						>
							- استفاده از بخش فروشگاه
						</Typography>
						<Typography paragraph component="p" variant="body2">
							ابتدا از قسمت <b>انتخاب برند</b> برند آنتی ویروس را
							انتخاب کرده سپس از قسمت <b>انتخاب محصول</b> آنتی
							ویروس مورد نظر را انتخاب کنید و در آخر برای مشاهده
							اطلاعات محصول از قسمت <b>اطلاعات محصول</b> بر روی{" "}
							<b>اطلاعات بیشتر ...</b> کلیک کنید.
						</Typography>
						<Divider className="my-2" />
						<Typography gutterBottom variant="h6" component="h3">
							اضافه‌کردن کالا به سبد‌خرید
						</Typography>
						<Typography paragraph component="p" variant="body2">
							پس از انتخاب کالایی که تصمیم نهایی برای خرید آن
							دارید، با کلیک‌کردن بر روی گزینه افزودن به سبد خرید،
							محصول وارد سبد خرید شما می‌شود برای نهایی کردن خرید
							کافسیت بر روی نمایش سبد خرید کلیک کنید و یا از منو
							اصلی سایت بر روی گزینه سبد خرید کلیک کنید. اگر قصد
							خرید کالاهای بیشتری را دارید، آنها را نیز به سبد
							خرید خود اضافه کنید تا به صورت یک سفارش برای شما
							پردازش و ارسال شوند.
						</Typography>
						<Divider className="my-2" />
						<Typography gutterBottom variant="h6" component="h3">
							نهایی‌کردن خرید
						</Typography>
						<Typography
							paragraph
							gutterBottom
							component="p"
							variant="body2"
						>
							پس از انتخاب کالاهای موردنظر و اضافه‌کردن آنها به
							سبد خرید، باید سفارش خود را طی ۲ مرحله زیر تکمیل و
							نهایی کنید:
						</Typography>
						<Typography
							paragraph
							gutterBottom
							component="p"
							variant="body2"
						>
							۱) ورود به آنتی‌ویروس, ۲) اطلاعات ارسال سفارش و روش
							پرداخت.
						</Typography>
						<Typography paragraph component="p" variant="body2">
							اگر بدون وارد شدن در سایت کالاهای موردنظرتان را به
							سبد خرید اضافه کرده باشید، باید در مرحله{" "}
							<b>ورود به آنتی ویروس</b> با وارد کردن نام کاربری و
							رمز عبور خود، وارد سایت ‏‌شوید. اگر قبلاً حساب
							کاربری در آنتی ویروس نداشته‌اید می‌‏‏توانید به راحتی
							در چند ثانیه و با وارد کردن ایمیل و مشخصات خود،
							ابتدا عضو سایت شده و سپس سبد خرید خود را ثبت کنید.
							سپس با طی مراحل بعدی، سفارش شما ثبت و آماده پردازش
							خواهد شد. در صورت وجود هرگونه سوال یا ابهامی
							می‌توانید به بخش پرسش‌های متداول مراجعه نمایید.
						</Typography>
					</Card>
				</Col>
			</Row>
		</>
	)
}

export default HelpPage
